import React from 'react';
import SectionHero from '../../SectionHero';
import SummaryDownloadBanner from './SummaryDownloadBanner';
import { SummaryDownloadBannerProps } from "../Types/SummaryDownloadBannerTypes";
import { SectionHeroProps } from '../../SectionHero/SectionHero';

const CONTENTFUL_SECTION_HERO_WITH_TEXT_AND_CTA = 'ContentfulSectionHeroWithTextAndCta';
const CONTENTFUL_SECTION_SUMMARY_DOWNLOAD_BANNER = 'ContentfulSectionSummaryDownloadBanner';

interface BannerPropType {
    banners:SectionHeroProps[] | SummaryDownloadBannerProps[],
    passEmailSurveyId:string
}

const SectionAssessmentBanners = ({banners, passEmailSurveyId = ""}:BannerPropType)=> {

    const bannerSections = banners && banners.length > 0 &&
        banners.map((item: any, qnum: any) => {
            switch (item.__typename) {
                case CONTENTFUL_SECTION_HERO_WITH_TEXT_AND_CTA: {
                    return (
                        <SectionHero key={qnum} name={item.name} textPosition={item.textPosition}
                            content={item.content} mirrorContent={item.mirrorContent}
                            responsiveImageCollection={item.responsiveImageCollection}
                        />
                    );
                }
                case CONTENTFUL_SECTION_SUMMARY_DOWNLOAD_BANNER: {
                    return (
                        <SummaryDownloadBanner
                            key={qnum}
                            name={item.__typename}
                            textPosition={item.textPosition}
                            header={item.header.raw}
                            headerColor={item.headerColor}
                            headerTextAlign={item.headerTextAlign}
                            nameInput={item.nameInput}
                            emailInput={item.emailInput}
                            privacyText={item.privacyText.raw}
                            privacyColor={item.privacyColor}
                            privacyTextAlign={item.privacyTextAlign}
                            button={item.downloadButton}
                            responsiveImageCollection={item.responsiveImageCollection}
                            emailSurveyId={passEmailSurveyId}
                        />
                    );
                }

                default:
                    return false;
            }
        });

    return <div>{bannerSections}</div>;

};

export default SectionAssessmentBanners;